import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import ModifierCode from "../../../../Utility/Crud/ModifierCode";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminModifierCodeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "code", name: "Code", type: "string", width: "200px" },
                    { key: "description", name: "Description", type: "string" },
                ]}
                rows={ModifierCode.sort(Object.values(this.context.modifierCodesIndexed))}
                onClick={(modifierCode) => {
                    this.props.history.push({
                        pathname: "/admin/modifierCode/" + modifierCode.id
                    });
                }}
            />
        );
    }
});